import { jsx as e } from "react/jsx-runtime";
import h from "react";
import { splitStringBySubstring as g } from "./helpers/splitStringBySubstring.js";
import c from "./HighlightSearch.module.css.js";
const f = (m) => {
  const { search: a, line: t, className: n = "", ...i } = m;
  if (typeof a != "string" || typeof t != "string" || a === "")
    return /* @__PURE__ */ e("span", { ...i, className: n, children: t });
  const s = a.split(",").map((r) => r.trim().toLowerCase()).filter(Boolean), p = t.toLowerCase();
  if (s.length > 1 && s.every((r) => p.includes(r)))
    return /* @__PURE__ */ e("span", { ...i, className: n, children: /* @__PURE__ */ e("mark", { className: c.mark, "data-test": "HighlightSearch_mark", children: t }) });
  const o = g(t, a);
  return o.length === 1 ? /* @__PURE__ */ e("span", { ...i, className: n, children: t }) : /* @__PURE__ */ e("span", { ...i, className: n, children: o.map((r, l) => l % 2 === 0 ? r === "" ? null : /* @__PURE__ */ e(h.Fragment, { children: r }, `${l}-${r}`) : /* @__PURE__ */ e(
    "mark",
    {
      className: c.mark,
      "data-test": "HighlightSearch_mark",
      children: r
    },
    `${l}-${r}`
  )) });
}, H = h.memo(f);
export {
  H as HighlightSearch
};
